import { render, staticRenderFns } from "./uploadInfo.vue?vue&type=template&id=1b3fbea6&scoped=true"
import script from "./uploadInfo.vue?vue&type=script&lang=js"
export * from "./uploadInfo.vue?vue&type=script&lang=js"
import style0 from "./uploadInfo.vue?vue&type=style&index=0&id=1b3fbea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3fbea6",
  null
  
)

export default component.exports